const col = {
  menu: { lg: 5, md: 5, xs: 0 },
  content: { lg: 19, md: 19, xs: 24 },
}

export default col
